export default "__VITE_ASSET__EL1$kFO5__"